import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import parse from 'html-react-parser';
import * as Icon from '../../Imports/Icons';
import Button from '@material-ui/core/Button';
import Axios from '../../Imports/Axios';
import ScoreGauge from '../../Imports/ScoreGauge'
import LinearProgress from '../../Imports/LinearProgress';
import { SaadDate } from '../../Imports/SaadDate';
let SaadDateObj = null;
// eslint-disable-next-line
SaadDateObj = SaadDate.then(obj => {
  SaadDateObj = new obj();
});
const useStyles = theme => ({
  toolbar: {
    minHeight: 40,
    background: 'rgba(56, 32, 110, 0.9)'
  }
});
class Default extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tasks: [],
      unSignedEvent: 0,
      unDoneTasks: 0,
      unreadLetters: 0,
      score: 0,
      scoreDetails: {},
      welcome: {},
      showData: false,
      dateFa: SaadDateObj.niceDate(SaadDateObj.parseDate(Date.now(), {
      ignoreTimeZone: false,
      showTime: false
    }), {
      showDay: true
    })
    };
  }
  async componentDidMount() {
    this.props.socket.on('tasksInDashboard', async () => {
      this.getData('noBackdrop');
    });
    await this.getData('noBackdrop');
  }
  async getData(backdropOption) {
    if (backdropOption === 'backdrop') {
      this.props.pageBackDrop(true);
    }
    let requestOptions = {
      url: 'dashboards/index'
    };
    try {
      const response = await Axios(requestOptions);
      if (response.data.status === 1000) {
        this.setState({
          tasks: response.data.data.tasks,
          unDoneTasks: response.data.data.unDoneTasks,
          unreadLetters: response.data.data.unreadLetters,
          unSignedEvents: response.data.data.unSignedEvents,
          welcome: response.data.data.welcome,
          score: response.data.data.score,
          scoreDetails: response.data.data.scoreDetails,
          showData: true
        });
        this.props.pageBackDrop(false);
      } else if (response.data.status !== 300) {
        this.props.pageSnackMessage({
          alertSeverity: 'error',
          alertMessage: response.data.message,
          openSnackbar: true
        });
        this.setState({
          showData: false
        });
        this.props.pageBackDrop(false);
      } else {
        this.setState({
          showData: false
        });
        this.props.pageBackDrop(false);
      }
    } catch (error) {
      console.log(error);
      this.props.pageSnackMessage({
        alertSeverity: 'error',
        alertMessage: 'عدم دسترسی به سرور',
        openSnackbar: true
      });
      this.setState({
        showData: false
      });
      this.props.pageBackDrop(false);
    }
  }
  async like() {
    if(this.state.welcome.liked) {
      return false
    }
    let requestOptions = {
      url: 'dashboards/like',
      params: {
        id: this.state.welcome._id
      }
    };
    try {
      const response = await Axios(requestOptions);
      if (response.data.status === 1000) {
        let welcome = this.state.welcome
        welcome.liked = true
        welcome.likes++
        this.setState({
          welcome: welcome
        })
      } 
    } catch (error) {
      console.log(error);
      this.props.pageSnackMessage({
        alertSeverity: 'error',
        alertMessage: 'عدم دسترسی به سرور',
        openSnackbar: true
      });
      this.setState({
        showData: false
      });
      this.props.pageBackDrop(false);
    }
  }
  pageBackDrop(option) {
    this.setState({
      openBackdrop: option
    });
  }
  pageSnackMessage(option) {
    this.setState({
      alertSeverity: option.alertSeverity,
      alertMessage: option.alertMessage,
      openSnackbar: option.openSnackbar
    });
  }
  render() {
    const {
      tasks,
      unreadLetters,
      unDoneTasks,
      unSignedEvents,
      welcome,
      score,
      scoreDetails,
      dateFa,
      showData
    } = this.state;
    const getNameOfUser = user => {
      if (user) {
        return `${user.published.name} ${user.published.family}`;
      } else {
        return 'نامشخص!';
      }
    };
    const getDayClassName = () => {
      let result = ""
      switch(welcome.time) {
        case "1":
          result = "welcome-box morning"
          break
        case "2":
          result = "welcome-box noon"
          break
        case "3":
          result = "welcome-box evening"
          break
        case "4":
          result = "welcome-box night"
          break
        
      }
      return result
    }
    const getStatus = status => {
      let result = null;
      switch (status) {
        case '0':
          result = <div className='color-red'>انجام نشده</div>;
          break;
        case '1':
          result = <div className='color-orange'>انجام شده در انتظار تایید</div>;
          break;
        case '2':
          result = <div className='color-green'><Icon.Save /></div>;
          break;
        default:
          result = null;
      }
      return result;
    };
    const getDateFa = (item) => {
      let result = ""
      switch(item) {
        case "week":
          result = dateFa.split(",")[0]
          break
        case "month":
          result = dateFa.split(",")[1].split(" ")[2]
          break
        case "day":
          result = dateFa.split(",")[1].split(" ")[1]
          break
        case "year":
          result = dateFa.split(",")[1].split(" ")[3]
          break
        
      }
      return result
    }
    
    return <div dir="rtl" className="panel-wrapper">
           <div className="actions">
      
       <Tooltip title="بارگیری مجدد" placement="right" classes={{
          tooltip: "toolTip",
          arrow: "toolTipArrow"
        }} arrow>
          <Button id="reloadDashboard" className="action-button" onClick={() => {
            this.setState({
              tasks: [],
              showData: false
            }, () => {
              this.getData('backdrop');
            });
          }}>
            <Icon.Refresh className="action-icon" />
          </Button>
       </Tooltip>

       <Tooltip title="راهنما" placement="right" classes={{
          tooltip: "toolTip",
          arrow: "toolTipArrow"
        }} arrow>
          <Button className="action-button help">
            <Icon.Help className="action-icon" />
          </Button>
       </Tooltip>

        </div>
            {showData ? <Grid container spacing={0} margin={10}>
              <Grid className="box" item xs={12} sm={10}>
                <div class={getDayClassName()}>

    <div class="welcome-message">
       {parse(welcome.text)}
    </div>

    <div class="welcome-actions">
        <span class={welcome.liked ? "like active" : "like"} onClick={() => {
          this.like()
        }}>❤</span>
        <span class="likes-count">{welcome.likes ? welcome.likes : ""}</span>
    </div>

</div>
                  
                        
              </Grid>
              <Grid className="box" item xs={12} sm={2}>
                <div className='calendar content'>
                  <div className='month'>{getDateFa("month")}</div>
                  <div className='day'>{getDateFa("day")}</div>
                  <div className='footer'>{getDateFa("week")}</div>
                  <div className='footer year'>{getDateFa("year")}</div>
                </div>
              </Grid>

              <Grid className="box" item xs={12} sm={3}>
                  <div className='dashboard-statics tasks' data-id="tasks_index" data-title="فهرست وظایف" data-icon="Tasks" data-controller="Tasks" data-action="index" onClick={this.props.openTab.bind(this)}>
                      <div className='ico'>
                        <Icon.Tasks />
                      </div>
                      <div className='title'>وظیفه انجام نشده</div>
                      <div className='value'>{unDoneTasks}</div>
                  </div>
              </Grid>

               <Grid className="box" item xs={12} sm={3}>
                  <div className='dashboard-statics letter' data-id="letters_inbox" data-title="نامه‌های دریافتی" data-icon="Mail" data-controller="Letters" data-action="inbox" onClick={this.props.openTab.bind(this)}>
                      <div className='ico'>
                        <Icon.Mail />
                      </div>
                      <div className='title'>نامه خوانده نشده</div>
                      <div className='value'>{unreadLetters}</div>
                  </div>
              </Grid>

              <Grid className="box" item xs={12} sm={3}>
                  <div className='dashboard-statics event' data-id="events_index" data-title="فهرست رویدادها" data-icon="Event" data-controller="Events" data-action="index" onClick={this.props.openTab.bind(this)}>
                      <div className='ico'>
                        <Icon.Event />
                      </div>
                      <div className='title'>صورتجلسه امضاء نشده</div>
                      <div className='value'>{unSignedEvents}</div>
                  </div>
              </Grid>

              <Grid className="box" item xs={12} sm={3}>
                  <div className='dashboard-statics bale' onClick={() => {
                    window.open('https://web.bale.ai/@mghgroup', '_blank');
                  }}>
                      <div className='ico'>
                        <Icon.Bale />
                      </div>
                      <div className='title'>کانال اطلاع‌رسانی</div>
                      <div className='value'>بله</div>
                  </div>
              </Grid>

              <Grid className="box" item xs={12} md={6}>
                <div className="content">
                   <div className="title">امتیازات سازمانی</div>
                   <div className='score'>
                    <ScoreGauge
                      title=""
                      value={this.state.score}
                      max={500}
                  />
                   </div>
                   <Table className="tb-score">
                    <TableBody>
                      <TableRow>
                        <TableCell align="right" component="th" scope="row">
                         <span>وضعیت تأهل</span> {scoreDetails.marital} از 30
                          <LinearProgress value={Number((scoreDetails.marital * 100 / 30).toFixed(2))} inTable={false} />
                        </TableCell>
                        <TableCell align="right" component="th" scope="row">
                         <span>مدرک تحصیلی</span> {scoreDetails.education} از 100
                          <LinearProgress value={Number((scoreDetails.education * 100 / 100).toFixed(2))} inTable={false} />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align="right" component="th" scope="row">
                         <span>دوره‌های آموزشی</span> {scoreDetails.courses} از 20
                          <LinearProgress value={Number((scoreDetails.courses * 100 / 20).toFixed(2))} inTable={false} />
                        </TableCell>
                        <TableCell align="right" component="th" scope="row">
                         <span>سوابق کاری</span> {scoreDetails.work} از 150
                          <LinearProgress value={Number((scoreDetails.work * 100 / 150).toFixed(2))} inTable={false} />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align="right" component="th" scope="row">
                         <span>عملکرد انضباطی</span> {scoreDetails.disciplinary} از 50
                          <LinearProgress value={Number((scoreDetails.disciplinary * 100 / 50).toFixed(2))} inTable={false} />
                        </TableCell>
                        <TableCell align="right" component="th" scope="row">
                         <span>گروه شغلی</span> {scoreDetails.workBase} از 150
                          <LinearProgress value={Number((scoreDetails.workBase * 100 / 150).toFixed(2))} inTable={false} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                   </Table>
                </div>
              </Grid>

              <Grid className="box" item xs={12} md={6}>
<div className="content">
                    <div className="title">وظایف امروز</div>
                    {tasks.length > 0 ? <TableContainer component={Paper}>
                      <Table className="tb-view">
                        <TableHead>
                          <TableRow>
                            <TableCell align="right">#</TableCell>
                            <TableCell align="right">عنوان</TableCell>
                            <TableCell align="right">مجری</TableCell>
                            <TableCell align="right">پیگیری</TableCell>
                            <TableCell align="right">وضعیت</TableCell>
                            <TableCell align="right"></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {tasks.map((item, i) => {
                    return <TableRow key={i}>
                                  <TableCell align="right" component="th" scope="row">
                                    {i + 1}
                                  </TableCell>
                                  <TableCell align="right" component="th" scope="row">
                                    {item.published.title}
                                  </TableCell>
                                  <TableCell align="right" component="th" scope="row">
                                    {getNameOfUser(item.published.assignedTo)}
                                  </TableCell>
                                  <TableCell align="right" component="th" scope="row">
                                    {getNameOfUser(item.published.admin)}
                                  </TableCell>
                                  <TableCell align="right" component="th" scope="row">
                                    {getStatus(item.published.status)}
                                  </TableCell>
                                  <TableCell align="left" component="th" scope="row">
                                  <Button data-document={item._id} data-id={`Tasks_view_${item._id}`} data-title="مشاهده وظیفه" data-icon="Tasks" data-controller="Tasks" data-action="view" className="tb-btn" type="button" onClick={this.props.openTab.bind(this)}>
                                      <Icon.View />
                                    </Button>
                                  </TableCell>
                                </TableRow>;
                  })}

                        </TableBody>
                      </Table>
                    </TableContainer> : <div className='happy'>
                     <Icon.Happy />
                     فعلا که خبری نیست!
                 </div>}
                      


                  </div>
              </Grid>

              
            </Grid> : <></>}
           

      </div>;
  }
}
export default withStyles(useStyles)(Default);